import React from 'react';

// The funder and affiliation pickers render an identical per-result output
// count — a right-aligned formatted number with a spoken aria-label. Only the
// i18n namespace varies, and it matches the picker's i18nKey, so both consumers
// build their renderResultExtras from this factory rather than duplicating it.
const createOutputCount = (i18nKey) =>
  function OutputCount(item) {
    if (!item.research_output_count) return null;
    const formatted = item.research_output_count.toLocaleString();
    const spoken = I18n.t(`Explorer.AdvancedSearch.fields.${i18nKey}.modal.output_count`, {
      count: item.research_output_count,
      count_formatted: formatted
    });
    return (
      <span className="ModalPicker-resultCount" aria-label={spoken}>
        {formatted}
      </span>
    );
  };

export default createOutputCount;
